export default "__VITE_ASSET__W3K9SNkN__"